<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">    
                        <h3 class="blue_accent--text text-uppercase">{{ $t('create_customer.new') }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">
                        <create-customer-form :customer="customer" :smart_values="smart_values" :smart_states="smart_states" ref="customer_form"></create-customer-form>
                    </v-form>
                    <v-row class=" py-0 mt-2" justify="center" align="center">
                        <v-col cols="6" justify="end" align="end">
                            <v-btn class="right px-3 mx-4" @click="cancel">
                                {{ $t('create_customer.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="save" v-permission="'client.create'">
                                {{ $t('create_customer.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
        </v-container>        
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>
import { createCustomerUseCase } from '../application/use_cases/create_customer_use_case';
import { createSmartValuesUseCase } from '../application/use_cases/create_smart_values_use_case';
import { HttpCustomerRepository } from '../infrastructure/customer_repository';
import { indexWarehousesUseCase } from '../../warehouses/application/use_cases/index_warehouse_use_case';
import { HttpWarehouseRepository } from '../../warehouses/infrastructure/repositories/warehouse_repository';
import { indexShippingAccountsUseCase } from '../../shipping_accounts/application/use_cases/index_shipping_accounts_use_case';
import { HttpShippingAccountsRepository } from '../../shipping_accounts/infrastructure/repositories/shipping_account_repository';

export default {
    computed: {},
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            customer: {
                name: "",
                social_reason: "",
                country: "",
                state: "",
                neighborhood: "",
                street: "",
                zipcode: "",
                external_number: "",
                internal_number: "",
                municipality: "",
                contact_phone: "",
                service_phone: "",
                email: "",
                is_national: 1,
                immex_ssn: '',
                rfe_idc: '',
                language: 'es',
                warehouses: [],
                fulfillment: 0,
                return_label: 0,
                shipments_notifications: 1,
                shipping_accounts: [],
                email_to_notify: [],
                operation_notifications: false,
                in_out_ad: 0,
                arrival_ad: 0,
                ramping_ad: 0,
                start_process_ad: 0,
                end_process_ad: 0,
                exit_truck_ad: 0,
                outcome_confirmation_ad: 0,
                operations_by_customer_ad: 0,
                stock_ad: 0,
                storage_policies_ad: 0,
                prepared_orders_ad: 0,
                operations_by_customer_time: "",
                stock_time: "",
                avoid_validations: false,
                rfid_by_product: 0,
                hd_services: 0,
                picking_required: 0,
                guides_service: false,
                cutoff_time: '14:00'
            },          
            settings: {
                fedex: {
                    shipping_service: 'FEDEX',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    zone_1: 0,
                    zone_2: 0,
                    zone_3: 0,
                    zone_4: 0,
                    zone_5: 0,
                    zone_6: 0,
                    zone_7: 0,
                    zone_8: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                quiken: {
                    shipping_service: 'QUIKEN',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    shipping_2kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                yego: {
                    shipping_service: 'YEGO',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    shipping_2kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                otra: {
                    shipping_service: 'OTRA',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    shipping_2kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                merq: {
                    shipping_service: 'MERQ',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    shipping_2kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                jtexpress: {
                    shipping_service: 'JTEXPRESS',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    shipping_2kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                afimex: {
                    shipping_service: 'AFIMEX',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    shipping_2kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                cexpress: {
                    shipping_service: 'CEXPRESS',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    shipping_2kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                tiui: {
                    shipping_service: 'TIUI',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    shipping_2kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                }
            },
            smart_values: {},
            smart_states: ["Aguascalientes" ,"Baja California" ,"Baja California Sur" ,"Campeche" ,"Chiapas" ,"Chihuahua" ,"Ciudad De Mexico" ,"Coahuila" ,"Colima" ,"Durango" ,"Guanajuato" ,"Guerrero" ,"Hidalgo" ,"Jalisco" ,"Estado De Mexico" ,"Michoacan" ,"Morelos" ,"Nayarit" ,"Nuevo Leon" ,"Oaxaca" ,"Puebla" ,"Queretaro" ,"Quintana Roo" ,"San Luis Potosi" ,"Sinaloa" ,"Sonora" ,"Tabasco" ,"Tamaulipas" ,"Tlaxcala" ,"Veracruz" ,"Yucatan" , "Zacatecas"]
        }
    },
    mounted(){
        this.index();
        this.$store.state.module = "headers.create_customer";
    },
    methods: {
        async index() {
            this.smart_states.forEach( x => {
                this.smart_values[x] = { option_1: '', option_2: '', option_3: '' };
            });

            try {
                this.customer.warehouses = [];
                const warehouses = await indexWarehousesUseCase(HttpWarehouseRepository);

                for(var i in warehouses){
                    this.customer.warehouses.push({ name: warehouses[i].name, value: false, is_rfid: false });
                }

            } catch (e) {
                console.log(e)
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            } 

            try {
                const shipping_accounts = await indexShippingAccountsUseCase(HttpShippingAccountsRepository);

                this.customer.shipping_accounts = shipping_accounts.data.data.map(x => {
                    return { name: x.attributes.name, value: false, service_type: x.attributes.service_type };
                })
            } catch (e) {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async save(){
            const validate = this.$refs.form.validate();
            var at_least_one_warehouse = false;

            this.customer.warehouses.forEach(x => {
                if(x.value == true) at_least_one_warehouse = true;
            });

            if(validate && at_least_one_warehouse){
                this.customer['settings'] = this.settings;
                if(this.customer.hd_services == true) this.customer.client_type = "HD";

                try {
                    const res = await createCustomerUseCase(this.customer, HttpCustomerRepository);
    
                    if(res.status === 201){
                        try {
                            const res_smart = await createSmartValuesUseCase(res.data.id, { states: this.$refs.customer_form.smart_values }, HttpCustomerRepository);
                            res_smart;

                            this.snackbar = {
                                visible: true,
                                color: 'success2',
                                text: this.$t('create_custom_agent.responses.success')
                            }
                            this.$router.push({ name: "CustomersIndex" });  
                        } catch (e) {
                            console.log(e);
                            this.snackbar = {
                                visible: true,
                                color: 'error',
                                text: e.response == null? e : e.response.data.message
                            }
                        }
                    }
                } catch (e) {
                    console.log(e);
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: e.response == null? e : e.response.data.message
                    }
                }
            }
            else {
                this.$store.state.loaderProps.visible = false;
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('create_customer.invalid_form')
                }
            }
        },
        cancel(){
            this.$router.go(-1);
        },
    },
    watch:{
        
    }
}
</script>

<style lang="css">
</style>